// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"f679eb5782797dc5","651":"3a61127a96893fb0"}[chunkId] + ".js";
};